/* Helpers */
import { usersOrder } from "../../../helper/orders";
/* Components */
import Dashboard from "../../../components/common/dashboard/Dashboard";
import Header from "../../../components/common/Header";
import Icon from "../../../components/common/Icon";
import SearchBox from "../../../components/common/SearchBox";
import {useEffect, useState} from "react";
import {getUserList} from "../../../api/admin/userReq";
import useAuth from "../../../hooks/useAuth";
import usePager from "../../../hooks/usePager";


export default function Users() {
    const sources = "fa fa-user";
    const { auth } = useAuth();
    const token = auth.token;
    const { currentPage, itemsPerPage, setTotalPages, setCurrentPage } = usePager();
    const [ userList, setUserList ] = useState();
    const [ totalItems, setTotalItems ] = useState();
    const [ filterParams, setFilterParams ] = useState({});
    const [ pageInitialized, setPageInitialized ] = useState(false);

    const apiUserList =  async () => {
        const response = await getUserList(token, currentPage, itemsPerPage, JSON.stringify(filterParams));
        setUserList(response?.users)
        setTotalItems(response?.totalItems)
    };

    useEffect(() => {
        const savedPage = localStorage.getItem("impersonate_return_page");
        if (savedPage) {
            const pageNumber = parseInt(savedPage, 10);
            if (pageNumber > 0) {
                setCurrentPage(pageNumber);
            }
            localStorage.removeItem("impersonate_return_page");
        }
        setPageInitialized(true);
    }, []);

    useEffect(() => {
        if (pageInitialized) {
            apiUserList()
        }
    },[ filterParams, currentPage, itemsPerPage, totalItems, pageInitialized ]);

    useEffect(() => {
        if (userList?.length < 1) {
            setCurrentPage(1)
        }
    }, [ userList ]);

    useEffect(() => {
        setCurrentPage(1)
        setTotalPages(Math.ceil(totalItems / itemsPerPage))
    }, [ filterParams, totalItems, itemsPerPage ]);

    const headers = [
        { label: "Id", key : "id" },
        { label :"Nom", key : "name" },
        { label :"Ville", key : "city" },
        { label :"Rôle", key : "role" },
        { label :"email", key : "lastName" },
        { label :"Prénom", key : "firstName" },
        { label :"Identifiant", key : "username" },
        { label :"Date création", key : "createdAt" },
        { label :"Activé", key : "active" }
    ];

    return (
        <>
            <main className="admin">
                <Header parent="Administration"
                        location="Utilisateurs"
                        slug="/admin/accueil"
                />
                <div className="content-container">
                    <Icon source={ sources } color="blue" span="Liste des Utilisateurs"/>
                    <SearchBox location="Utilisateurs" headers={headers} filename="Utilisateurs" setFilterParams={setFilterParams} />
                    <div className="dashboard">
                        <Dashboard totalItems={totalItems} apiUserList={apiUserList} location="Utilisateurs" dataObject={ userList || [] } order={ usersOrder } />
                    </div>
                </div>
            </main>
        </>
    )
}